import { Instance } from 'mobx-state-tree'
import { PlayerGameStatsModelBase } from './PlayerGameStatsModel.base'

/* The TypeScript type of an instance of PlayerGameStatsModel */
export interface PlayerGameStatsModelType extends Instance<typeof PlayerGameStatsModel.Type> {}

/* A graphql query fragment builders for PlayerGameStatsModel */
export {
  selectFromPlayerGameStats,
  playerGameStatsModelPrimitives,
  PlayerGameStatsModelSelector
} from './PlayerGameStatsModel.base'

/**
 * PlayerGameStatsModel
 */
export const PlayerGameStatsModel = PlayerGameStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
